import Vue from 'vue'
import VueI18n from 'vue-i18n'
import englishMessages from '@/locale/english'
import spanishMessages from '@/locale/spanish'

const defaultLocale = 'es'

const messages = {
  'en': englishMessages,
  'es': spanishMessages
}

const dateTimeFormats = {
  'en': {
    short: {
      year: '2-digit', month: '2-digit', day: '2-digit'
    },
    long: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true
    }
  },
  'es': {
    short: {
      year: '2-digit', month: '2-digit', day: '2-digit'
    },
    long: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true
    }
  }
}

Vue.use(VueI18n)

export default new VueI18n({
  locale: defaultLocale,
  messages,
  silentFallbackWarn: true,
  dateTimeFormats
})
